import type { ColumnsType } from 'antd/lib/table'
import { ProjectDiscountPayload } from '../models'
import {
  CustomHeaderText,
  ProjectDiscountTypeColumn,
  ProjectDiscountDatesColumn,
  CustomText,
  ProjectDiscountAmountTypeColumn,
  ProjectDiscountAmountColumn,
  ProjectDiscountActionsColumn,
  ProjectDiscountMovileViewColumn,
  ProjectDiscountVintagesColumn
} from 'src/components'

const discountListColumns: ColumnsType<ProjectDiscountPayload> = [
  {
    title: () => <CustomHeaderText text='Projects.Fields.Type' />,
    responsive: ['sm'],
    render: (_, discount) => <ProjectDiscountTypeColumn discount={discount} />
  },
  {
    title: () => <CustomHeaderText text='Discount.Dates' />,
    responsive: ['sm'],
    render: (_, discount) => <ProjectDiscountDatesColumn discount={discount} />
  },
  {
    title: () => <CustomHeaderText text='Discount.MinVolume' />,
    responsive: ['sm'],
    render: (_, discount) => <div className='has-text-centered'>
      <CustomText label={discount.min_volume || '-'}  />
    </div>
  },
  {
    title: () => <CustomHeaderText text='Projects.Vintages' />,
    responsive: ['sm'],
    render: (_, discount) => <ProjectDiscountVintagesColumn discount={discount} />
  },
  {
    title: () => <CustomHeaderText text='Discount.AmountType' />,
    responsive: ['sm'],
    render: (_, discount) => <ProjectDiscountAmountTypeColumn discount={discount} />
  },
  {
    title: () => <CustomHeaderText text='Deposits.Amount' />,
    responsive: ['sm'],
    render: (_, discount) => <ProjectDiscountAmountColumn discount={discount} />
  },
  {
    title: () => <CustomHeaderText text='Deposits.Actions' />,
    responsive: ['sm'],
    render: (_, discount) => <ProjectDiscountActionsColumn discount={discount} />
  },
  {
    title: () => <CustomHeaderText text='Discount.Title' />,
    responsive: ['xs'],
    render: (_, discount) => <ProjectDiscountMovileViewColumn discount={discount} />
  },
]

export default discountListColumns
